export class Site
{
    IDSite!: number
    IDPlaque?: number
    Descr!: string | number
    AutovistaActif?: boolean
    RefMotoActif?: boolean
    RefVdlActif?: boolean
    KifalActif?: boolean
    Plaque_Libelle?: string
    Plaque_IDActivite?: number
    IDActivite?: number
    EstFictif?: boolean
    AutobizActif?: boolean

    constructor(data?: Partial<Site>) {
        Object.assign(this, data)
    }

    getLabel = () => {
        return this.Descr
    }

    getValue = () => {
        return this.IDSite
    }
}
